import React from "react";
import PropTypes from "prop-types";
import ImageGallery from "react-image-gallery";

import { getImageUrl } from "utils";
import { GalleryContainer } from "./styles";
import playVideoImage from "assets/images/play-video.png";
import failLoadImage from "assets/images/fail-load-image.png";

import "react-image-gallery/styles/css/image-gallery.css";
// import "react-image-gallery/styles/scss/image-gallery.scss";

const ImageGalleryModal = ({ images }) => {
  const imagesUrls = images?.map((url) => {
    if (url?.contentType.startsWith("video/")) {
      return {
        embedUrl: getImageUrl(url?.documentUrl),
        original: getImageUrl(url?.documentUrl),
        thumbnail: playVideoImage,
        renderItem: (item) => (
          <video
            width="100%"
            height="100%"
            controls
            disablePictureInPicture
            controlsList="nodownload noplaybackrate nofullscreen"
          >
            <source src={item?.embedUrl} />
          </video>
        ),
      };
    } else {
      return {
        original: getImageUrl(url?.documentUrl),
        thumbnail: getImageUrl(url?.documentUrl),
      };
    }
  });

  return (
    <GalleryContainer>
      <ImageGallery
        items={imagesUrls}
        showIndex={false}
        showThumbnails
        lazyLoad
        showPlayButton={false}
        thumbnailPosition="bottom"
        onErrorImageURL={failLoadImage}
        useBrowserFullscreen={false}
        showBullets
      />
    </GalleryContainer>
  );
};

ImageGalleryModal.propTypes = {
  images: PropTypes.array,
};
export default ImageGalleryModal;
